import { FaWindows, FaLinux, FaApple } from "react-icons/fa";

const osOptions = [
  {
    id: "windows",
    label: "Windows",
    icon: FaWindows,
  },
  {
    id: "linux",
    label: "Linux",
    icon: FaLinux,
  },
  {
    id: "darwin",
    label: "macOS",
    icon: FaApple,
  },
];

export default osOptions;
